/* Quenard — JS global: navegación, búsqueda, carrito AJAX, filtros, announcement bar */
(function () {
  'use strict';

  var Q = window.Quenard || {};

  /* ------------------------------------------------------------------ */
  /* Utilidades                                                          */
  /* ------------------------------------------------------------------ */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || Q.moneyFormat || '€{{amount_with_comma_separator}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) number = 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }
  Q.formatMoney = formatMoney;
  window.Quenard = Q;

  function trapBody(open) {
    document.body.classList.toggle('no-scroll', open);
  }

  var mqMobile = window.matchMedia('(max-width: 989px)');
  var mqDesktop = window.matchMedia('(min-width: 990px)');

  /* ------------------------------------------------------------------ */
  /* Barra de anuncios rotativa                                          */
  /* ------------------------------------------------------------------ */

  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    var messages = bar.querySelectorAll('[data-announcement-message]');
    if (messages.length < 2) return;
    var index = 0;
    var timer = null;
    var speed = parseInt(bar.getAttribute('data-autorotate'), 10);

    function show(i) {
      messages[index].classList.remove('is-active');
      index = (i + messages.length) % messages.length;
      messages[index].classList.add('is-active');
    }
    function start() {
      if (!speed) return;
      stop();
      timer = setInterval(function () { show(index + 1); }, speed);
    }
    function stop() { if (timer) clearInterval(timer); }

    var prev = bar.querySelector('[data-announcement-prev]');
    var next = bar.querySelector('[data-announcement-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    start();
  });

  /* ------------------------------------------------------------------ */
  /* Cabecera sticky: sombra al hacer scroll                             */
  /* ------------------------------------------------------------------ */

  var header = document.querySelector('[data-header]');
  if (header) {
    // El sticky/ocultar va sobre el wrapper .shopify-section (su contenedor es el
    // <body>), no sobre el <header> directo. Los drawers (menú, buscador) están
    // FUERA del <header> dentro del mismo wrapper, y solo se abren con el scroll
    // bloqueado, así que el transform de ocultado no los afecta.
    var headerWrap = header.closest('.shopify-section') || header;
    var stickyDesktop = header.getAttribute('data-sticky-desktop') === 'true';
    var hideMobile = header.getAttribute('data-hide-mobile') === 'true';

    if (stickyDesktop || hideMobile) {
      // Leemos scrollY ANTES de modificar clases para no forzar un reflow
      // sincrónico (la invalidación de estilo + lectura de geometría seguidas
      // es lo que PageSpeed marca como "redistribución forzada").
      var lastY = window.scrollY;
      var ticking = false;

      headerWrap.classList.add('header__wrap-sticky');
      if (stickyDesktop) headerWrap.classList.add('is-sticky-desktop');
      if (hideMobile) headerWrap.classList.add('is-hide-mobile');

      var headerScroll = function () {
        var y = window.scrollY;
        headerWrap.classList.toggle('is-scrolled', y > 8);

        if (hideMobile && mqMobile.matches) {
          if (y > lastY && y > 140) {
            headerWrap.classList.add('is-hidden');     // baja → oculta
          } else if (y < lastY - 4) {
            headerWrap.classList.remove('is-hidden');  // sube → muestra al instante
          }
        } else {
          headerWrap.classList.remove('is-hidden');
        }
        lastY = y;
        ticking = false;
      };

      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(headerScroll); ticking = true; }
      }, { passive: true });
      // Primera pasada en el siguiente frame: evita leer geometría de forma
      // sincrónica justo tras añadir las clases (reflow forzado).
      requestAnimationFrame(headerScroll);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Cabecera overlay: transparente arriba → blanco translúcido al scroll */
  /* ------------------------------------------------------------------ */
  var headerGroup = document.querySelector('.header-group-sticky');
  if (headerGroup) {
    var hgTicking = false;
    var hgScroll = function () {
      var scrolled = window.scrollY > 8;
      headerGroup.classList.toggle('is-scrolled', scrolled);
      // Clase global para que carrito y buscador (fuera de la cabecera) igualen
      // la translucidez de la barra según el scroll.
      document.body.classList.toggle('page-scrolled', scrolled);
      hgTicking = false;
    };
    window.addEventListener('scroll', function () {
      if (!hgTicking) { window.requestAnimationFrame(hgScroll); hgTicking = true; }
    }, { passive: true });
    requestAnimationFrame(hgScroll);

    // Publica la posición inferior de la barra para colocar el menú móvil justo
    // debajo (la barra está pinada arriba, así que su 'bottom' es estable).
    var setHeaderBottom = function () {
      document.documentElement.style.setProperty(
        '--header-bottom',
        Math.round(headerGroup.getBoundingClientRect().bottom) + 'px'
      );
    };
    requestAnimationFrame(setHeaderBottom);
    window.addEventListener('load', setHeaderBottom);
    window.addEventListener('resize', setHeaderBottom, { passive: true });
  }

  /* ------------------------------------------------------------------ */
  /* Drawer de menú móvil                                                */
  /* ------------------------------------------------------------------ */

  var menuDrawer = document.querySelector('[data-menu-drawer]');
  function toggleMenu(open) {
    if (!menuDrawer) return;
    menuDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    trapBody(open);
    var toggle = document.querySelector('[data-menu-open]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ------------------------------------------------------------------ */
  /* Modal de búsqueda                                                   */
  /* ------------------------------------------------------------------ */

  var searchModal = document.querySelector('[data-search-modal]');
  function toggleSearch(open) {
    if (!searchModal) return;
    searchModal.setAttribute('aria-hidden', open ? 'false' : 'true');
    trapBody(open);
    if (open) {
      var input = searchModal.querySelector('[data-search-input]');
      if (input) setTimeout(function () { input.focus(); }, 120);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Búsqueda predictiva (Section Rendering API nativa de Shopify)       */
  /* ------------------------------------------------------------------ */

  var searchInput = document.querySelector('[data-search-input]');
  var predictiveBox = document.querySelector('[data-predictive-results]');

  if (searchInput && predictiveBox && Q.routes && Q.routes.predictiveSearch) {
    var pTimer = null;
    var pController = null;
    var pLast = '';

    function clearPredictive() {
      predictiveBox.innerHTML = '';
      predictiveBox.classList.remove('is-visible');
    }

    function renderPredictive(q) {
      if (q === pLast) return;
      pLast = q;
      if (pController) pController.abort();
      pController = ('AbortController' in window) ? new AbortController() : null;

      var url = Q.routes.predictiveSearch +
        '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,page,article' +
        '&resources[limit]=5&resources[options][unavailable_products]=last';

      predictiveBox.classList.add('is-loading');
      fetch(url, pController ? { signal: pController.signal } : undefined)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var section = temp.querySelector('.shopify-section');
          predictiveBox.innerHTML = section ? section.innerHTML : html;
          predictiveBox.classList.remove('is-loading');
          predictiveBox.classList.add('is-visible');
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          predictiveBox.classList.remove('is-loading');
        });
    }

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(pTimer);
      if (q.length < 2) { pLast = ''; clearPredictive(); return; }
      pTimer = setTimeout(function () { renderPredictive(q); }, 200);
    });

    /* Navegación con teclado por las sugerencias */
    searchInput.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = predictiveBox.querySelectorAll('[data-predictive-link]');
      if (!links.length) return;
      e.preventDefault();
      var current = document.activeElement;
      var idx = Array.prototype.indexOf.call(links, current);
      var next = e.key === 'ArrowDown' ? idx + 1 : idx - 1;
      if (next < 0) { searchInput.focus(); return; }
      if (next >= links.length) next = links.length - 1;
      links[next].focus();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Carrito: drawer, añadir, actualizar                                 */
  /* ------------------------------------------------------------------ */

  var cartDrawer = document.querySelector('[data-cart-drawer]');

  function toggleCart(open) {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    trapBody(open);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-hidden', count === 0);
    });
  }

  function replaceCartDrawer(html) {
    if (!cartDrawer || !html) return;
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var fresh = temp.querySelector('[data-cart-drawer-inner]');
    var current = cartDrawer.querySelector('[data-cart-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
  }

  function replaceCartPage(html) {
    var cp = document.querySelector('[data-cart-page]');
    if (!cp || !html) return;
    var temp = document.createElement('div');
    temp.innerHTML = html;
    var fresh = temp.querySelector('[data-cart-page]');
    if (fresh) cp.replaceWith(fresh);
  }

  /* Muestra un aviso en la línea (carrito y/o cajón) cuando el stock topa */
  function showLineNotice(line, text, max) {
    document.querySelectorAll('[data-line="' + line + '"]').forEach(function (lineEl) {
      var notice = lineEl.querySelector('[data-line-notice]');
      if (notice) { notice.textContent = text; notice.hidden = false; }
      var input = lineEl.querySelector('[data-line-input]');
      if (input && max != null) input.max = max;
    });
  }

  /* Aviso de tope de stock en el selector de cantidad (página de producto) */
  function showQtyNotice(scope, max) {
    if (!scope) return;
    var notice = scope.querySelector('[data-qty-notice]');
    if (!notice) return;
    var u = max === 1 ? ' unidad disponible.' : ' unidades disponibles.';
    notice.textContent = 'Solo quedan ' + max + u;
    notice.hidden = false;
  }

  /* Actualiza el contador del carrito en segundo plano (no bloquea la UI) */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () { /* silencioso */ });
  }

  /* Añadir al carrito (formulario de producto y quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form], [data-quick-add]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var buttonText = button ? button.querySelector('[data-add-button-text]') || button : null;
    var originalText = buttonText ? buttonText.textContent : '';
    if (button) button.disabled = true;

    var formData = new FormData(form);
    if (cartDrawer) formData.append('sections', 'cart-drawer');

    fetch(Q.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          var msg = result.data && (result.data.description || result.data.message);
          alert(msg || Q.strings.errorQuantity);
          return;
        }

        // Abrir el cajón con UNA sola petición: el add ya devuelve el HTML del
        // drawer (sections), así que lo pintamos y abrimos al instante. El
        // contador de la cabecera se refresca aparte, sin bloquear la apertura.
        if (cartDrawer) {
          if (result.data.sections && result.data.sections['cart-drawer']) {
            replaceCartDrawer(result.data.sections['cart-drawer']);
          }
          toggleCart(true);
          if (buttonText) {
            buttonText.textContent = Q.strings.added;
            setTimeout(function () { buttonText.textContent = originalText; }, 1800);
          }
          refreshCartCount();
        } else {
          window.location.href = Q.routes.cart;
        }
      })
      .catch(function () { alert(Q.strings.errorQuantity); })
      .finally(function () { if (button) button.disabled = false; });
  });

  /* Cambiar cantidades / eliminar líneas */
  var cartUpdateTimer = null;

  /* Pinta el carrito (cajón y/o página) y avisa si el stock topó la cantidad */
  function applyCart(cart, cartPageId, line, requested) {
    if (!cart) return;
    if (typeof cart.item_count === 'number') updateCartCount(cart.item_count);
    if (cart.sections) {
      if (cart.sections['cart-drawer']) replaceCartDrawer(cart.sections['cart-drawer']);
      if (cartPageId && cart.sections[cartPageId]) replaceCartPage(cart.sections[cartPageId]);
    }
    if (requested > 0 && cart.items && cart.items[line - 1]) {
      var actual = cart.items[line - 1].quantity;
      if (actual < requested) {
        var unidades = actual === 1 ? ' unidad disponible.' : ' unidades disponibles.';
        showLineNotice(line, 'Lo sentimos, solo quedan ' + actual + unidades, actual);
      }
    }
  }

  function changeLine(line, requested) {
    var cartPage = document.querySelector('[data-cart-page]');
    var cartPageId = cartPage && cartPage.getAttribute('data-section-id');
    var sectionsList = [];
    if (cartDrawer) sectionsList.push('cart-drawer');
    if (cartPageId) sectionsList.push(cartPageId);
    var sectionsParam = sectionsList.join(',');

    var body = { line: line, quantity: requested };
    if (sectionsParam) body.sections = sectionsParam;

    fetch(Q.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (result.ok) {
          applyCart(result.data, cartPageId, line, requested);
          return;
        }
        // 422: se pidió más stock del disponible. Shopify ya capó el carrito al
        // máximo, pero responde con error y sin secciones → resincronizamos con
        // update.js (sin cambios) para repintar y avisar con la cantidad real.
        fetch(Q.routes.cart + '/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: {}, sections: sectionsParam })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) { applyCart(cart, cartPageId, line, requested); })
          .catch(function () { window.location.reload(); });
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line-input'), 10);
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(function () { changeLine(line, qty); }, 350);
  });

  /* ------------------------------------------------------------------ */
  /* Filtros de colección (facets)                                       */
  /* ------------------------------------------------------------------ */

  var facetsPanel = document.querySelector('[data-facets-panel]');
  var facetsForm = document.querySelector('[data-facets-form]');

  function submitFacets() {
    if (!facetsForm) return;
    var params = new URLSearchParams();
    Array.prototype.forEach.call(facetsForm.elements, function (el) {
      if (!el.name || el.disabled) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '') return;
      params.append(el.name, el.value);
    });
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  if (facetsForm) {
    facetsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitFacets();
    });
    facetsForm.addEventListener('change', function (e) {
      // En escritorio aplica al instante; en móvil se usa el botón "Aplicar"
      if (mqDesktop.matches && e.target.type === 'checkbox') {
        submitFacets();
      }
    });
  }

  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var hidden = document.querySelector('[data-sort-hidden]');
      if (hidden && facetsForm) {
        hidden.value = sortSelect.value;
        submitFacets();
      } else {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', sortSelect.value);
        window.location.href = window.location.pathname + '?' + params.toString();
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Clics: un único manejador delegado para toda la página              */
  /* (menú, buscador, carrito, filtros, cantidades). Reduce el coste por */
  /* interacción frente a tener varios listeners en document.            */
  /* ------------------------------------------------------------------ */

  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Menú móvil */
    if (t.closest('[data-menu-open]')) toggleMenu(true);
    if (t.closest('[data-menu-close]')) toggleMenu(false);

    /* Buscador */
    if (t.closest('[data-search-open]')) toggleSearch(true);
    if (t.closest('[data-search-close]')) {
      toggleSearch(false);
      if (predictiveBox) { predictiveBox.innerHTML = ''; predictiveBox.classList.remove('is-visible'); }
    }

    /* Carrito (abrir/cerrar) */
    var cartOpener = t.closest('[data-cart-open]');
    if (cartOpener && cartDrawer) {
      e.preventDefault();
      toggleCart(true);
    }
    if (t.closest('[data-cart-close]')) toggleCart(false);

    /* Filtros (abrir/cerrar panel) */
    if (facetsPanel && t.closest('[data-filters-open]')) {
      facetsPanel.classList.add('is-open');
      trapBody(true);
    }
    if (facetsPanel && t.closest('[data-filters-close]')) {
      facetsPanel.classList.remove('is-open');
      trapBody(false);
    }

    /* Carrito: eliminar línea */
    var removeBtn = t.closest('[data-line-remove]');
    if (removeBtn) {
      changeLine(parseInt(removeBtn.getAttribute('data-line-remove'), 10), 0);
      return;
    }

    /* Carrito: botones de cantidad +/- */
    var qtyBtn = t.closest('[data-quantity-minus], [data-quantity-plus]');
    if (qtyBtn) {
      var wrapper = qtyBtn.closest('.quantity');
      var input = wrapper && wrapper.querySelector('.quantity__input');
      if (!input) return;
      var step = qtyBtn.hasAttribute('data-quantity-plus') ? 1 : -1;
      var min = parseInt(input.min || '0', 10);
      var max = parseInt(input.max || '0', 10);
      var current = parseInt(input.value, 10) || 0;
      var nextVal = Math.max(min, current + step);
      if (max > 0 && nextVal > max) nextVal = max;
      if (nextVal === current) {
        // Ya en el tope de stock: avisar (solo donde haya selector de producto)
        if (step > 0 && max > 0) showQtyNotice(qtyBtn.closest('.product__quantity'), max);
        return;
      }
      input.value = nextVal;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      toggleMenu(false);
      toggleSearch(false);
      toggleCart(false);
      document.querySelectorAll('.facets.is-open').forEach(function (f) { f.classList.remove('is-open'); });
      trapBody(false);
    }
  });

  /* ------------------------------------------------------------------ */
  /* Vídeos en tarjetas de producto y hero: autoplay solo en pantalla    */
  /* (IntersectionObserver) para no saturar CPU/GPU con todos a la vez   */
  /* ------------------------------------------------------------------ */

  var videoObserver = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var a = v.play();
            if (a && a.catch) a.catch(function () { /* autoplay bloqueado: queda el póster */ });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function initInlineVideos() {
    document.querySelectorAll('.product-card__media video, .hero__media video').forEach(function (video) {
      if (video.dataset.inlineInit) return;
      video.dataset.inlineInit = '1';
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.loop = true;
      if (videoObserver) {
        videoObserver.observe(video);
      } else {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () { /* autoplay bloqueado: queda el póster */ });
      }
    });
  }
  initInlineVideos();
  document.addEventListener('shopify:section:load', initInlineVideos);

  /* ------------------------------------------------------------------ */
  /* Vistos recientemente (lectura y render en cualquier página)         */
  /* ------------------------------------------------------------------ */

  document.querySelectorAll('[data-recently-viewed]').forEach(function (section) {
    var grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    var max = parseInt(section.getAttribute('data-max'), 10) || 4;
    var currentHandle = section.getAttribute('data-current-handle');
    var items = [];
    try {
      items = JSON.parse(localStorage.getItem('quenard:recent') || '[]');
    } catch (err) { items = []; }

    items = items.filter(function (item) { return item.handle !== currentHandle; }).slice(0, max);
    if (!items.length) return;

    grid.innerHTML = items
      .map(function (item) {
        var img = item.image
          ? '<img class="product-card__image" src="' + item.image + '" alt="" loading="lazy">'
          : '';
        return (
          '<div class="product-card">' +
          '<a href="' + item.url + '" class="product-card__media" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<div class="product-card__info">' +
          '<h3 class="product-card__title"><a href="' + item.url + '">' + item.title + '</a></h3>' +
          '<div class="price"><span class="price__current">' + item.price + '</span></div>' +
          '</div></div>'
        );
      })
      .join('');
    section.hidden = false;
  });
})();
